<template>
    <b-container fluid>
        <b-form-group class="form-spacing">
            <b-row class="my-3" col>
                <b-col cols="2">
                    <label>Created By:</label>
                </b-col>
                <b-col cols="3">
                    <b-form-input :value="getCurrentOverride.username" disabled data-test="username"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col cols="2">
                    <label>Date Created:</label>
                </b-col>
                <b-col cols="3">
                    <b-form-input :value="getCurrentOverride.created" disabled data-test="created" type="date"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col cols="2">
                    <label>Comment:</label>
                </b-col>
                <b-col cols="8">
                    <b-textarea
                        rows="3"
                        :value="getCurrentOverride.comment"
                        @input="
                            editOverride({ prop: 'comment', value: $event });
                            v$.getCurrentOverride['comment'].$touch();
                        "
                        :disabled="disabled"
                        :state="inputState('comment')"
                        data-test="comment"
                    ></b-textarea>
                </b-col>
            </b-row>
        </b-form-group>
    </b-container>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { mapGetters, mapMutations } from "vuex";
import { required, } from "vuelidate/lib/validators";

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    props: {
        disabled: Boolean,
    },
    computed: {
        ...mapGetters(["getCurrentOverride", "getSelectedRule"]),
    },
    methods: {
        ...mapMutations(["editOverride"]),
        inputState(prop) {
            return !this.v$.getCurrentOverride[prop].$error ? null : !this.v$.getCurrentOverride[prop].$invalid;
        },
    },
    validations() {
        return {
            getCurrentOverride: {
                comment: {
                    required,
                },
            },
        };
    },
};
</script>

<style scoped>
.form-spacing {
    margin-top: -1.5rem;
    margin-bottom: 0;
}

.btn-ok {
    background-color: #00afef !important;
}
</style>

<style>
/* .custom-control-input:checked ~ .custom-control-label::before {
    color: #006891;
    border-color: #006891;
    background-color: white !important;
    box-shadow: 0 3px 2px rgb(233 236 239 / 5%);
} */
</style>